import Style from './index.module.less'
import BlockTitle from '@/components/BockTitle'
import LatestBlockOne from '@/components/LatestBlockOne'
import MeEmpty from '@/components/MeEmpty'
import RealtimeTransaction from '@/components/RealtimeTransaction'
import { type Block, type Transition } from '@/hoxStore/interface'
import classNames from 'classnames'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

const Index = ({
  showRight = false,
  blocks = [],
  transitions = [],
}: {
  showRight?: boolean
  blocks: Block[]
  transitions: Transition[]
}) => {
  const { t } = useTranslation()
  const [footKey, setFootKey] = useState(0)
  const timeId = useRef<NodeJS.Timeout | null>(null)

  // useEffect(() => {
  //   window.addEventListener('resize', () => {
  //     if (timeId.current) {
  //       clearTimeout(timeId.current)
  //     }
  //     timeId.current = setTimeout(() => {
  //       setFootKey(new Date().getTime())
  //     }, 500)
  //   })
  //   return () => {
  //     window.removeEventListener('resize', () => {})
  //   }
  // }, [])
  return (
    <div
      className={classNames({
        [Style.wrap]: true,
        // [Style.showRight]: showRight,
      })}
    >
      <div className={classNames(Style.moduleTwoItem, Style.moduleTwoItemLeft)}>
        {/* 最新区块 */}
        <BlockTitle title={t('explorer_9')}></BlockTitle>
        {blocks.length ? (
          <LatestBlockOne key={footKey} blocks={blocks.slice(0, 9)}></LatestBlockOne>
        ) : (
          <div className={Style.noData}>
            <MeEmpty text={t('explorer_233')}></MeEmpty>
          </div>
        )}
      </div>
      <div className={Style.moduleTwoItem}>
        {/* 实时交易区块数 */}
        <BlockTitle title={t('explorer_10')}></BlockTitle>
        {blocks.length ? (
          <RealtimeTransaction blockNext={blocks}></RealtimeTransaction>
        ) : (
          <div className={Style.noData}>
            <MeEmpty text={t('explorer_233')}></MeEmpty>
          </div>
        )}
      </div>
    </div>
  )
}

export default Index
